import gql from 'graphql-tag';

import userFragment from './user-fragment';

export default gql`
  mutation resetPasswordUserMutation(
    $newPassword: String!
    $codeForResetPassword: String!
  ) {
    resetPasswordUserMutation(
      newPassword: $newPassword
      codeForResetPassword: $codeForResetPassword
    ) {
      title
      message
      record {
        ...UserFragment
      }
    }
  }
  ${userFragment}
`;
